// src/components/LinkAccountInvite.jsx
import React, { useState } from 'react'
import {
    Container,
    Box,
    FormControl,
    FormLabel,
    Input,
    Button,
    Heading,
    Text,
    VStack,
    useToast,
} from '@chakra-ui/react'
import useHasPermission from "../../../hooks/useHasPermission"
import {useNotification} from "../../../contexts/NotificationContext"
import axiosInstance from "../../../api/axiosInstance"


export default function LinkAccountInvite() {
    const isPremium = useHasPermission('premium')
    const [email, setEmail] = useState('')
    const [error, setError] = useState('')
    const toast = useToast()
    const { addNotification, addErrorNotifications } = useNotification()

    if (!isPremium) {
        return (
            <Container py={8}>
                <Text>You need a premium account to invite others.</Text>
            </Container>
        )
    }

    const handleSubmit = async e => {
        e.preventDefault()
        setError('')

        try {
            const { data } = await axiosInstance.post('/accounts/invite', { email })
            addNotification(data.message, 'success')
            setEmail('')
        } catch (err) {
            const msg = err.response?.data?.error || 'Failed to send invite'
            setError(msg)
            addErrorNotifications(err.response?.data)
        }
    }

    return (
        <Container maxW="lg" py={8} mt={20}>
            <Box bg="white" shadow="md" borderRadius="md" p={6}>
                <Heading size="lg" mb={6} textAlign="center">
                    Link one of your accounts
                </Heading>
                <Box as="form" onSubmit={handleSubmit}>
                    <VStack spacing={4}>
                        <FormControl isRequired>
                            <FormLabel>Invitee Email</FormLabel>
                            <Input
                                type="email"
                                value={email}
                                onChange={e => setEmail(e.target.value)}
                                placeholder="user@example.com"
                            />
                        </FormControl>
                        <Button type="submit" colorScheme="blue" width="full" isDisabled={!email}>
                            Send Invite
                        </Button>
                        {error && (
                            <Text color="red.500" textAlign="center">
                                {error}
                            </Text>
                        )}
                    </VStack>
                </Box>
            </Box>
        </Container>
    )
}